import React, { useEffect, useState, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  MenuItem,
  TextField,
  LinearProgress
} from "@material-ui/core";

import { CopyToClipboard } from "react-copy-to-clipboard";

import Alert from '@material-ui/lab/Alert';

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CloseIcon from '@material-ui/icons/Close';

import { PageContext } from "../../../contexts/PageContext";
import { UserContext } from "../../../contexts/UserContext";
import InfoTooltip from "../../general/InfoTooltip";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  selectKN: {
    width: 350,
    maxWidth: "100%",
    marginRight: 10
  },
  createButton: {
    marginTop: 10
  }
}));

export default function LiegenschaftChecklistDialog(
  {
    liegenschaftIndex,
    //creditFunctions,
    portals,
    credit_id,
    metafields,
  }) {
  const theme = useTheme();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [isCreatingSignature, setIsCreatingSignature] = useState(false);
  const [checklist, setChecklist] = useState(false);
  /*
    {
      value: "human readable but escaped filename",
      kn: int,
      id: // setting id 
      key: "xxxx" //setting key 
    }
  */


  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);

  useEffect(() => {
    if (open) {
      if (portals && portals.length > 0 && !checklist) {
        getChecklist();
      }
      setIsCreatingSignature(false);
    }
  }, [open]);



  const createSignatureRequest = (document, callback) => {
    setIsCreatingSignature(true);
    const data = {
      title: "Liegenschaftscheckliste Liegenschaft " + liegenschaftIndex,
      persons: [document.kn],
      common_document: false,
      setting_id: document.hasOwnProperty("id") ? parseInt(document.id) : 0,
      metafield_id: document.hasOwnProperty("metafield_id") ? parseInt(document.metafield_id) : 0,
      liegenschaft_index: liegenschaftIndex
    };

    let url = `${process.env.REACT_APP_API_SERVICE_URL}/signatures/${credit_id}`;
    const options = {
      url: url,
      data: data,
      method: 'post',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        setIsCreatingSignature(false)
        if (callback)
          callback(res.data);

      })
      .catch((err) => {
        console.log(err);
      });
  }

  // try to get existing checklist or create a new one from template
  const getChecklist = () => {
    let url = `${process.env.REACT_APP_API_SERVICE_URL}/signatures/${credit_id}`;
    const options = {
      url: url,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        if (res.data.length) {
          // während der Entwicklung sollen endlos viele neue Checklists erstellt werden
          // dazu die nächsten 3 Zeilen auskommentieren
          const existingChecklist = res.data.find(signature => signature.title === "Liegenschaftscheckliste Liegenschaft " + liegenschaftIndex);
          if (existingChecklist)
            setChecklist(existingChecklist);
          else
            getChecklistFromTemplate();
        } else
          getChecklistFromTemplate();
      })
      .catch((err) => {
        console.log(err);
      });
  }


  const getChecklistFromTemplate = () => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/file/liegenschaft_checklist`,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then(({ data }) => {
        setChecklist({ ...data, "kn": 0 })
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message)
          pageContext.setErrorMessage(err.response.data.message);
        else
          pageContext.setErrorMessage("Die Einstellung konnte nicht geladen werden!");
      });
  }


  // Testbetrieb
  // if (userContext.user.role !== "administrator")
  //   return <></>;

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<CheckBoxIcon />}
        onClick={() => {
          setOpen(true);
        }}
      >
        Liegenschafts-Checkliste
      </Button>
      <InfoTooltip
        content="Fülle die Checkliste gemeinsam mit den Kunden aus und lass diese dann über das Kundenportal unterzeichnen."
      />
      <Dialog
        onClose={() => { setOpen(false) }}
        open={open}
        fullWidth={true}
        maxWidth="sm">
        <DialogTitle>
          Liegenschafts-Checkliste
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {isCreatingSignature && (
          <LinearProgress />
        )}
        <DialogContent>
          {checklist && checklist.external_id ?
            <Alert severity="info">Die Checkliste für Liegenschaft {liegenschaftIndex} wurde bereits angelegt.</Alert>
            : <>
              <DialogContentText>Fülle die Checkliste gemeinsam mit den Kunden aus und lass diese dann über das Kundenportal unterzeichnen.</DialogContentText>
              {portals.length === 0 &&
                <Alert severity="info">Um die Checkliste dann auch von Kreditnehmern unterschreiben zu lassen leg bitte zuerst das Kundenportal für die jeweiligen Kreditnehmer an.</Alert>
              }
              {portals.length > 0 && !checklist.value &&
                <Alert severity="warning">Bitte lade in den Einstellungen erst eine Vorlage für die Checkliste hoch.</Alert>
              }
              {checklist.value && checklist.hasOwnProperty('viewer_urls')
                ?
                <Button color="primary" variant="contained" href={checklist.viewer_urls[0].url} target="_blank">
                  Checkliste ausfüllen
                </Button>
                : <>
                  <TextField
                    className={classes.selectKN}
                    label="Wer wird das Dokument unterzeichnen?"
                    helperText="Wähle einen Kreditnehmer"
                    value={checklist.kn ? checklist.kn : 0}
                    onChange={(e) => {
                      setChecklist({ ...checklist, kn: parseInt(e.target.value) });
                    }}
                    disabled={isCreatingSignature}
                    select
                  >
                    <MenuItem key="kn0" value={0}>-</MenuItem>
                    {[1, 2, 3, 4].map(i =>
                      <MenuItem
                        key={"kn" + i}
                        disabled={portals.find(portal => portal.person_index === i) === undefined}
                        value={i}>
                        Kreditnehmer {i} {portals.find(portal => portal.person_index === i) === undefined ? "(noch kein Portal angelegt)" : ""}
                      </MenuItem>
                    )}
                  </TextField>
                  <Button
                    disabled={!checklist.kn || isCreatingSignature}
                    onClick={() => {
                      createSignatureRequest(checklist, (viewer_urls) => {
                        pageContext.setInfoMessage("Das Dokument wurde angelegt.");
                        setChecklist(checklist => { return { ...checklist, viewer_urls: viewer_urls }; });
                      });
                      //setOpen(false);
                    }}
                    color="primary"
                    variant="contained"
                    className={classes.createButton}
                    autoFocus>
                    Checkliste anlegen
                  </Button>
                </>
              }
            </>
          }
          <DialogContentText>

          </DialogContentText>
        </DialogContent>
      </Dialog>



      {/* <Dialog
        onClose={() => { setRequestSignatureDocument(false) }}
        open={Boolean(requestSignatureDocument)}
        fullWidth={true}
        maxWidth="md"
        >
        <DialogTitle>Unterschrift anfordern</DialogTitle>
        {requestSignatureDocument && !requestSignatureDocument.hasOwnProperty('viewer_urls') &&
          <DialogContent>
            <DialogContentText>Sende das Dokument {requestSignatureDocument.value} an die Kreditnehmer zur Unterschrift.</DialogContentText>
            {[1, 2, 3, 4].map(i =>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isCreatingSignature || portals.find((portal) => portal.person_index == i) === undefined}
                    checked={requestSignatureDocument['kn' + i]}
                    onChange={(e) => {
                      setRequestSignatureDocument(doc => {
                        doc['kn' + i] = e.target.checked;
                        return { ...doc };
                      })
                    }}
                    
                  />
                }
                key={requestSignatureDocument.key + "_kn" + i}
                label={"Kreditnehmer " + i}
              />
            )}
          </DialogContent>
        }
        {requestSignatureDocument && requestSignatureDocument.hasOwnProperty('viewer_urls') &&
          <DialogContent>
            <DialogContentText>Füge jetzt noch die Felder für die Unterschriften ein:</DialogContentText>
            {
              requestSignatureDocument.viewer_urls.map(viewer => 
                <Button color="primary" variant="contained" className={classes.addFieldsButton} key={viewer.person_index} href={viewer.url} target="_blank">
                  Felder {viewer.person_index > -1 ? "für KN" + viewer.person_index : "" } einfügen
                </Button>)
            }
            <br/><br/>
            <DialogContentText>...und klick dann auf "Fertig"</DialogContentText>
          </DialogContent>
        }
        {
          requestSignatureDocument.hasOwnProperty('viewer_urls')
          ? <DialogActions>
              <Button onClick={()=>{setRequestSignatureDocument(false)}} color="primary">
                Fertig
              </Button>
            </DialogActions>
          : <DialogActions>
              <Button
                onClick={() => { setRequestSignatureDocument(false) }}
                disabled={isCreatingSignature}
                color="primary">
                abbrechen
              </Button>
              <Button
                color="primary"
                variant="contained"
                disabled={
                  isCreatingSignature ||
                  (
                    !requestSignatureDocument['kn1']
                    && !requestSignatureDocument['kn2']
                    && !requestSignatureDocument['kn3']
                    && !requestSignatureDocument['kn4']
                  )
                }
                onClick={() => {
                  createSignatureRequest(requestSignatureDocument, (viewer_urls) => {
                    console.log(viewer_urls);
                    pageContext.setInfoMessage("Das Dokument wurde angelegt und steht den Kreditnehmern jetzt im Kundenportal zur Verfügung.");
                    setRequestSignatureDocument(requestSignatureDocument => { return {...requestSignatureDocument, viewer_urls:viewer_urls}; });
                  });
                }}
                >
                Dokument senden
              </Button>
            </DialogActions>
          }
      </Dialog> */}
    </>
  );
}
